export default __webpack_public_path__ + "static/training-03b7d8a41f84b1a09bc38e863da24117.jpg";